import camelcaseKeysDeep from 'camelcase-keys-deep';

import { getDynamicContent } from '../api';
import {
  DYNAMIC_CONTENT_FETCHING,
  DYNAMIC_CONTENT_FETCHED_ERROR,
  DYNAMIC_CONTENT_FETCHED,
} from './';

export default function fetchDynamicContent(slug) {
  return async (dispatch, getStore) => {
    const { dynamicContent } = getStore();
    if (dynamicContent.dynamicContentFetched) {
      return;
    }
    dispatch({ type: DYNAMIC_CONTENT_FETCHING });

    try {
      const getDynamicContentResponse = await getDynamicContent(slug);

      dispatch({
        type: DYNAMIC_CONTENT_FETCHED,
        dynamicContent: camelcaseKeysDeep(getDynamicContentResponse),
      });
    } catch (error) {
      dispatch({ type: DYNAMIC_CONTENT_FETCHED_ERROR });
      console.warn(error);
    }
  };
}
